import { DeepResearchCard, DeepResearchCompContent, DeepResearchCompTitle } from './deep-research-shared';

import type { PlainTextAnswer } from '@/entities/ask-syncly/ask-syncly-types';

export function PlainText({ title, content }: PlainTextAnswer) {
  return (
    <DeepResearchCard>
      <DeepResearchCompTitle>{title}</DeepResearchCompTitle>
      <DeepResearchCompContent className="mt-5">{content}</DeepResearchCompContent>
    </DeepResearchCard>
  );
}
